import React from "react";
import Footer from "../common/Footer";
import SideHeader from "../login/SideHeader";

const LoginLayout = ({ children }) => {
  return (
    <div className="container-fluid vh-100 d-flex flex-column">
      <div className="row login-page-container" style={{ height: "91vh" }}>
        <div className="col-lg-4 d-none d-lg-flex align-items-center sideheader-container">
          <SideHeader />
        </div>
        <div className="login-layout-child-container col-lg-8 d-flex align-items-center justify-content-center">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginLayout;
